<template>
  <LayoutSite>
    <Formulario titulo="Usuários" v-if="!frmcadastro">
      <v-card-title>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="openform('novo')"
          :disabled="!permissoes.usuario_incluir"
        >Novo Usuário</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.email }}</td>
            <td class="text-xs-right">{{ props.item.meta }}</td>
            <td class="text-xs-right">{{ props.item.perfil_descr }}</td>
            <td class="text-xs-right">{{ props.item.email_usu }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>
    <Formulario :titulo="titulo" v-if="frmcadastro">
      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nome" autofocus v-model="usuario.name"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Login" v-model="usuario.email"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Senha"
                v-model="usuario.password"
                :type="showpass ? 'text' : 'password'"
                :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass = !showpass"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Confirmação Senha"
                v-model="usuario.password_confirmation"
                :type="showconf ? 'text' : 'password'"
                :append-icon="showconf ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showconf = !showconf"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Meta" v-model="usuario.meta"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                label="Perfil"
                v-model="usuario.perfil_id"
                :items="perfis"
                item-text="nome"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" v-if="isAdmin">
              <v-autocomplete
                label="Empresa"
                v-model="usuario.empresa_id"
                :items="empresas"
                item-text="nome"
                item-value="id"
                autofocus
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Email" v-model="usuario.email_usu"></v-text-field>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="error"
            @click="confirmaExcluir()"
            v-if="excluir"
            :disabled="!permissoes.usuario_excluir"
          >EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            type="submit"
            :disabled="!permissoes.usuario_alterar"
          >SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir este Usuário?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>
                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario,
  },
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Nome", value: "name", align: "left" },
        { text: "Login", value: "email" },
        { text: "Meta", value: "meta" },
        { text: "Perfil", value: "perfil_descr" },
        { text: "Email", value: "email_usu" },
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      erros: [],
      perfis: [],
      empresas: [],
      showpass: false,
      showconf: false,
      isAdmin: false,
      usuario: {
        id: 0,
        name: "",
        password: "",
        password_confirmation: "",
        email: "",
        meta: 0,
        perfil_id: 0,
        empresa_id: 0,
        email_usu: "",
      },
      permissoes: {
        usuario: false,
        usuario_incluir: false,
        usuario_alterar: false,
        usuario_excluir: false,
      },
    };
  },
  created: function () {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.usuario) this.$router.push("/#");
    } else this.$router.push("/#");

    this.isAdmin = permAux.admin;
  },
  methods: {
    getData: function () {
      this.$http
        .get(this.$urlAPI + "/usuario", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => (this.items = response.data));

      this.$http
        .get(this.$urlAPI + "/perfil", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => (this.perfis = response.data));
      this.$http
        .get(this.$urlAPI + "/empresa", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => (this.empresas = response.data));
    },
    openform: function (opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Novo Usuário";
        this.usuario.id = 0;
        this.usuario.name = "";
        this.usuario.email = "";
        this.usuario.meta = 0;
        this.usuario.password = "";
        this.usuario.password_confirmation = "";
        this.usuario.perfil_id = 0;
        this.usuario.empresa_id = 0;
        this.usuario.email_usu = "";
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Usuário";

        this.$http
          .get(this.$urlAPI + "/usuario/" + id, {
            headers: {
              authorization: "Bearer " + this.$store.getters.getToken,
            },
          })
          .then((response) => {
            this.usuario = response.data;
          });
      }
    },
    salvar: function () {
      if (!this.usuario.empresa_id) this.usuario.empresa_id = 0;

      if (this.excluir) {
        this.$http
          .post(this.$urlAPI + "/usuario/" + this.usuario.id, this.usuario, {
            headers: {
              authorization: "Bearer " + this.$store.getters.getToken,
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch((e) => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/usuario", this.usuario, {
            headers: {
              authorization: "Bearer " + this.$store.getters.getToken,
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch((e) => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function () {
      this.exclusao = true;
    },
    deletar: function () {
      this.$http
        .delete(this.$urlAPI + "/usuario/" + this.usuario.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch((e) => {
          this.erros = e.response.data.erros;
        });
    },
  },
};
</script>
